import { Box } from '@mui/material';

const Flexbox = ({ children, ...props }) => (
  <Box display="flex" {...props}>
    {children}
  </Box>
);

export default Flexbox;
